import { useEffect, useState } from "react";

//components
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import Lottie from "react-lottie";
//hooks
import { useMyTimelines } from "hooks/timeline";
import { useTimelinePreferences, usePreferenceDetails } from "hooks/preference";
//providers
import { useTimelineState } from "providers/TimelineProvider";
import { usePreferenceState } from "providers/PreferenceProvider";
//assets
import loadingAnimation from "assets/lotties/rightPanelLoading.json";

function Timelines({ setRightState, band, setActiveTab }) {
  const [remainingUrlsToCache, setRemainingUrlsToCache] = useState([]);
  const [cachedUrls, setCachedUrls] = useState([]);
  const [timeline, setTimeline] = useTimelineState();
  const [preferences, setPreferences] = usePreferenceState();
  const [timelines, setTimelines] = useState([]);
  const [selectedTimeline, setSelectedTimeline] = useState(null);
  const [selectedTimelinePreferences, setSelectedTimelinePreferences] =
    useState(null);
  const { mutate, isLoading } = useMyTimelines();
  const { mutate: mutatePreferences, isLoading: isLoadingPreferences } =
    useTimelinePreferences();
  const {
    mutate: mutatePreferenceDetails,
    isLoading: isLoadingPreferenceDetails,
  } = usePreferenceDetails();

  useEffect(() => {
    mutate(
      { band: band || "original" },
      {
        onSuccess: (response) => {
          if (response && response.status === "OK") {
            setTimelines(response.timelines);
          }
        },
        onError: (error) => {
          // console.log(error);
        },
      }
    );
  }, [band, mutate]);

  useEffect(() => {
    if (selectedTimeline) {
      mutatePreferences(
        { timelineId: selectedTimeline._id },
        {
          onSuccess: (response) => {
            if (response && response.status === "OK") {
              setSelectedTimelinePreferences(response.preferences);
            }
          },
        }
      );
    }
  }, [selectedTimeline, mutatePreferences]);

  useEffect(() => {
    navigator.serviceWorker.addEventListener("message", (event) => {
      if (event.data.type === "CACHE_CHECK_RESPONSE") {
        if (!event.data.ok) {
          setRemainingUrlsToCache((current) => [...current, event.data.url]);
          navigator.serviceWorker.ready.then((res) =>
            res.active.postMessage({
              type: "CACHE_URL",
              url: event.data.url,
              cacheTitle: event.data.cacheTitle,
            })
          );
        }
        if (event.data.ok) {
          setCachedUrls((current) => [...current, event.data.url]);
        }

        return;
      }
      if (event.data.type === "URL_CACHE_COMPLETE") {
        setCachedUrls((current) => [...current, event.data.url]);
        setRemainingUrlsToCache((current) =>
          current.filter((url) => url !== event.data.url)
        );
      }
    });
  }, []);

  return (
    <>
      {isLoading || isLoadingPreferenceDetails ? (
        <Lottie
          options={{
            loop: true,
            autoplay: true,
            animationData: loadingAnimation,
            rendererSettings: {
              preserveAspectRatio: "xMidYMid slice",
            },
            initialSegment: [11, 121],
          }}
          height={"100%"}
          width={"80%"}
        />
      ) : (
        <Grid
          container
          columnSpacing={2}
          style={{
            height: "100%",
            width: "100%",
            alignSelf: "center",
            padding: "1% 6% 0% 6%",
            overflow: "auto",
          }}
        >
          <Grid item xs={12}>
            {timelines.map((timeline, index) => {
              return (
                <>
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      padding: "1%",
                      margin: "1%",
                      borderColor: "#55ff55",
                      borderWidth: "1px",
                      borderStyle: "solid",
                      backgroundColor:
                        timeline._id === selectedTimeline?._id &&
                        remainingUrlsToCache.length === 0
                          ? "#22ff22"
                          : "#55ff5500",
                    }}
                    onClick={() => {
                      setSelectedTimeline(timeline);
                      let urls = Object.entries(timeline.layers)
                        .map(([layerName, layer]) => layer.url)
                        .filter((url) => url);
                      for (let url of urls) {
                        navigator.serviceWorker.ready.then((registration) =>
                          registration.active.postMessage({
                            type: "CACHE_CHECK",
                            cacheTitle: timeline.title.replace(" ", ""),
                            url,
                          })
                        );
                      }
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        display:
                          timeline._id !== selectedTimeline?._id && "none",
                        left: "3%",
                        height: "10%",
                        top: "85%",
                        width: `${
                          (94 /
                            (remainingUrlsToCache.length + cachedUrls.length)) *
                          cachedUrls.length
                        }%`,
                        backgroundColor: "#55ff55",
                      }}
                    >
                      &nbsp;
                    </div>
                    <Typography
                      variant="body2"
                      style={{
                        color:
                          timeline._id === selectedTimeline?._id &&
                          remainingUrlsToCache.length === 0
                            ? "#000000"
                            : "#55ff55",
                      }}
                    >
                      {index + 1}. {timeline.title}***
                      {new Date(timeline.createdAt).toLocaleDateString()}***
                      {new Date(timeline.updatedAt).toLocaleString()}
                    </Typography>
                  </div>
                  {timeline?._id === selectedTimeline?._id &&
                    selectedTimelinePreferences &&
                    remainingUrlsToCache.length === 0 && (
                      <div
                        style={{
                          paddingLeft: "10%",
                        }}
                      >
                        {selectedTimelinePreferences.map(
                          (preference, index) => {
                            return (
                              <div
                                style={{
                                  width: "100%",
                                  padding: "1%",
                                  margin: "1%",
                                  borderColor: "#55ff55",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                onClick={() => {
                                  if (remainingUrlsToCache.length > 0) return;

                                  mutatePreferenceDetails(
                                    { preferenceId: preference._id },
                                    {
                                      onSuccess: (response) => {
                                        if (
                                          response &&
                                          response.status === "OK"
                                        ) {
                                          setPreferences(response.preference);
                                          setTimeline(timeline);
                                          setActiveTab(0);
                                          setRightState("navigator");
                                        }
                                      },
                                    }
                                  );
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  style={{
                                    color: "#55ff55",
                                  }}
                                >
                                  {index + 1}.
                                  {new Date(
                                    preference.createdAt
                                  ).toLocaleDateString()}
                                  ***
                                  {new Date(
                                    preference.updatedAt
                                  ).toLocaleString()}
                                </Typography>
                              </div>
                            );
                          }
                        )}
                      </div>
                    )}
                </>
              );
            })}
          </Grid>
        </Grid>
      )}
    </>
  );
}

export default Timelines;
